export function loadScript(src: string): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');

    script.onload = () => resolve();
    script.onerror = () => reject();
    script.src = src;

    document.head.appendChild(script);
  });
}

export function pollUntilClose(window: Window): Promise<void> {
  return new Promise<void>((resolve) => {
    const interval = setInterval(() => {
      if (window.closed) {
        clearInterval(interval);
        resolve();
      }
    }, 500);
  });
}

export function addOverflowHidden() {
  document.body.style.overflow = 'hidden';
}

export function removeOverflowHidden() {
  document.body.style.overflow = '';
}

export function hideIntercom() {
  document.querySelector('.intercom-lightweight-app')?.classList.add('hidden');
}
export function showIntercom() {
  document.querySelector('.intercom-lightweight-app')?.classList.remove('hidden');
}

export function setHeaderZindex() {
  const header = document.querySelector<HTMLElement>('nz-header');
  if (header) {
    header.style.zIndex = '1002';
  }
}
export function unsetHeaderZindex() {
  const header = document.querySelector<HTMLElement>('nz-header');
  if (header) {
    header.style.zIndex = null;
  }
}
